import './style.scss'

const prefixCls = 'sl-avatar';

const Avatar = {
  name:'Avatar',
  props:['size','shape','icon','src'],
  computed:{
    classes(){
      return [`${prefixCls}-${this.size}`,{
        [`${prefixCls}`]:true,
        [`${prefixCls}-square`]:this.shape === 'square' ,
        [`${prefixCls}-icon`]:!!this.icon,
      }]
    }
  },
  methods:{

  },
  render(){
    // const node = this.icon ? <Icon type={this.cion} > : null
    const { $scopedSlots ,src , icon } = this
    let node;
    if( $scopedSlots.default ){
      node = $scopedSlots.default()
    }else if( src ){
      node = <img src={src} />
    }else if(icon){
      node = <Icon type={icon} />
    }

    return <span class={this.classes}>{node}</span>
  }
}

export default Avatar